export const FETCH_FR_RECOVERY_POINTS_START = "FETCH_FR_RECOVERY_POINTS_START";
export const FETCH_FR_RECOVERY_POINTS_SUCCESS =
  "FETCH_FR_RECOVERY_POINTS_SUCCESS";
export const FETCH_FR_RECOVERY_POINTS_FAILURE =
  "FETCH_FR_RECOVERY_POINTS_FAILURE";
export const CHANGE_FR_RECOVERY_POINT = "CHANGE_FR_RECOVERY_POINT";
export const FETCH_FILES_START = "FETCH_FILES_START";
export const FETCH_FILES_SUCCESS = "FETCH_FILES_SUCCESS";
export const FETCH_FILES_FAILURE = "FETCH_FILES_FAILURE";
export const TOGGLE_SELECT_ALL_FILES = "TOGGLE_SELECT_ALL_FILES";
export const TOGGLE_FILE_SELECTION = "TOGGLE_FILE_SELECTION";
export const TOGGLE_SHIFT_FILE_SELECTION = "TOGGLE_SHIFT_FILE_SELECTION";
export const INITIATE_RESTORE = "INITIATE_RESTORE";
export const PATTERN_SEARCH_START = "PATTERN_SEARCH_START";
export const CHANGE_SEARCH = "CHANGE_SEARCH";
export const DOWNLOAD_RESTORE_FILES_START = "DOWNLOAD_RESTORE_FILES_START";
export const UPDATE_FR_RECOVERY_POINT_SUCCESS =
  "UPDATE_FR_RECOVERY_POINT_SUCCESS";
export const STORE_REQUEST_PARAMS = "STORE_REQUEST_PARAMS";
export const CLEAR_FILE_RESTORE = "CLEAR_FILE_RESTORE";
export const REMOVE_RESTORE_URL_LOADER = "REMOVE_RESTORE_URL_LOADER";
export const DISABLE_RESTORE = "DISABLE_RESTORE";
export const ENUM_FOLDER = "ENUM_FOLDER";
export const ENUM_FOLDER_RESPONSE = "ENUM_FOLDER_RESPONSE";
export const CREATE_FOLDER = "CREATE_FOLDER";
export const CREATE_FOLDER_RESPONSE = "CREATE_FOLDER_RESPONSE";
export const CREATE_FOLDER_POP = "CREATE_FOLDER_POP";
export const SELECT_CUSTOM_PATH = "SELECT_CUSTOM_PATH";
export const SET_RESTORE_LOCATION = "SET_RESTORE_LOCATION";
export const CONFIRM_CUSTOM_PATH = "CONFIRM_CUSTOM_PATH";
export const DOWNLOAD_RESTORE_ISO_START = "DOWNLOAD_RESTORE_ISO_START";
export const CHANGE_FILE_RESTORE_TARGET_MACHINE =
  "CHANGE_FILE_RESTORE_TARGET_MACHINE";
export const POPULATE_UPDATED_VOLUMES_FR = "POPULATE_UPDATED_VOLUMES_FR";
export const FETCH_UPDATED_VOLUMES_FR = "FETCH_UPDATED_VOLUMES_FR";
